const alphabet = '23456789abcdefghijkmnpqrstuvwxyz';
const idLenght = 5;

function generate() {
    return Array.from({length: idLenght}).reduce((carry, current) =>
        carry + alphabet.charAt(Math.floor(Math.random() * alphabet.length))
    , '');
}

function isValid(id) {
    if (typeof id !== 'string') {
        return false;
    }

    if (id.length !== idLenght) {
        return false;
    }

    return id.split('').every(character => alphabet.includes(character));
}

export default { generate, isValid }



// WEBPACK FOOTER //
// ./resources/assets/js/utils/RoomId.js